<template>
  <div class="modalAdd">
    <b-modal id="modalAddFolder" ref="modalAddFolder" centered modal-class="modal-rename modal-radius modal-no-border top-mb" no-close-on-backdrop>
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <div class="btn-closeModal" @click="hideModal">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main files" :class="{'chrome': checkChrome, 'firefox': checkFirefox }">
        <h2 class="title text-center">フォルダ追加</h2>
        <div class="text-center">
          <div class="folder">
            <img src="@img/folder.svg" class="img-folder" />
          </div>
        </div>
        <div class="form-group">
          <label for="name" class="label-form">フォルダ名<span class="required">*</span></label>
          <div class="input-group">
            <input type="text" id="name" class="input-form" placeholder="フォルダ名を入力してください" :class="formatName()" v-model="name">
            <small v-if="!$v.name.required && invalid" class="text-input error">{{message.FOLDER_REQUIRED}}</small>
            <small v-if="$v.name.required && invalid && !$v.name.valid" class="text-input error">{{message.FOLDER_NAME_FORMAT}}</small>
            <small v-if="errorName" class="text-input error">{{nameError(errorName[0])}}</small>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
          <button
          class="btn btn-rounder btn-primary btn-contact"
          type="button" @click="addFolder">保存</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import { required } from 'vuelidate/lib/validators'
import {MESSAGE} from '@/utils/errorjapanese'
import errorMessage from '@/utils/errormessage'
import {mapState} from 'vuex'
export default {
  name: 'AddFolder',
  data () {
    return {
      modalShow: false,
      name: '',
      invalid: false,
      message: MESSAGE,
      checkChrome: false,
      checkFirefox: false
    }
  },
  validations: {
    name: {
      required,
      valid (name) {
        return !name.includes('/')
      }
    }
  },
  components: {
    'b-modal': BModal
  },
  watch: {
    'name' () {
      this.$store.commit('adminFolder/CHANGE_ERROR_NAME', '')
    }
  },
  methods: {
    back () {
      this.$emit('pageIndexBack')
    },
    formatName () {
      return ((!this.$v.name.required || !this.$v.name.valid) && this.invalid) || this.errorName ? 'error' : ''
    },
    addFolder (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.$store.dispatch('adminFolder/addFolder', {name: this.name, folder_parent_id: this.$route.params.folder_id, modal: this.hideModal, company_id: this.$route.params.id, clear: this.clearName, back: this.back})
    },
    hideModal () {
      this.name = ''
      this.invalid = false
      this.$store.commit('adminFolder/CHANGE_ERROR_NAME', '')
      this.$root.$emit('bv::hide::modal', 'modalAddFolder', '#modalAddFolder')
    },
    nameError (value) {
      return errorMessage.errorFolder(value)
    },
    clearName () {
      this.name = ''
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  computed: {
    ...mapState({
      errorName: state => state.adminFolder.errorName
    })
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/auth/listfile.scss";
.mw-253{
  max-width: 253px;
}
.form-group {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/FolderManagerment/FolderAdd.vue